import React from "react";

const Animation = () => {
  return (
    <div className="w-full h-full relative before bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent -translate-x-full animate-[shimmer_2s_infinite]"></div>
  );
};

export default Animation;
